import { Injectable } from "@angular/core";
import {throwError } from "rxjs";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse
} from "@angular/common/http";


@Injectable()
export class ApiService {
  constructor(public http: HttpClient) {}
  token : string = localStorage.getItem('access_token');
  urlLink:string = 'https://api.oppinar.com.br/v1';
  httpOptions = {
    headers: new HttpHeaders()
  };

  public getUrl(cnpj){
    let api_url = this.urlLink+'/info/'+cnpj
    return this.http.get<any>(api_url,this.httpOptions);
  }

  public getRegion(group){
    let api_url = this.urlLink+'/info/'+group+'/regions'
    return this.http.get<any>(api_url,this.httpOptions);
  }

  public getStores(group,region){
    if(region){
      let api_url = this.urlLink+'/info/'+group+'/'+region+'/stores'
      return this.http.get<any>(api_url,this.httpOptions);
    }
    else{
      let api_url = this.urlLink+'/info/'+group+'/stores'
      return this.http.get<any>(api_url,this.httpOptions);
    }
  }

  public postUrl(obj){
    let api_url = this.urlLink+'/evaluation'
    return this.http.post<any>(api_url,obj,this.httpOptions,);
  }

}
